<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mb-0">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Lista de Inscriptos
            {{ sistemaCompetencia === "Torneo" ? "del torneo" : "de la liga" }}:
            {{ infoTorneo }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="mt-4">
            <v-col cols="9" sm="5" md="5">
              <v-text-field
                v-model="paciente.dni"
                prepend-icon="mdi-account"
                hint="Ingrese el DNI del jugador y apriete enter o toque fuera de este cuadro de texto. Si el jugador ya existe, se verán sus datos. Si el jugador no existe, deberá buscar un jugador valido para agregar a la lista de inscriptos. Puede también buscar el jugador por apellido y nombre haciendo click en la lupa"
                label="D.N.I"
                dense
                @keypress="onlyNumber"
                @keypress.enter="$event.target.blur()"
                @blur="buscarPacienteDni"
                maxlength="9"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2" class="d-flex">
              <v-btn color="primary" @click="buscarPaciente">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.apellidos"
                prepend-icon="mdi-account"
                label="Apellidos"
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.nombres"
                prepend-icon="mdi-account"
                label="Nombres"
                dense
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense v-if="deporte === 'Futbol'">
            <v-col cols="12" sm="6" md="6">
              <v-select
                v-model="equipo"
                :items="equipos"
                label="Equipo"
                :rules="[(v) => !!v || 'Equipo es requerido']"
                prepend-icon="mdi-account"
                required
                persistent-hint
                hint="Siempre es preferible definir primero los nombres de los equipos dentro del torneo antes de cargar las inscripciones de los jugadores"
                dense
                no-data-text="No hay equipos designados para el torneo"
              />
            </v-col>
          </v-row>
          <v-alert
            class="mt-4"
            color="purple"
            dark
            outlined
            v-if="deporte === 'Futbol' && !equipos.length"
          >
            Para inscribir jugadores a la competición, configure la misma y
            designe los equipos.
          </v-alert>
          <v-card-actions v-else>
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="esPublico"
              label="Es público (no jugador registrado)"
              color="orange"
              dense
              hide-details
              class="mr-4"
            ></v-checkbox>
            <v-btn
              color="primary"
              :disabled="
                !paciente.idPaciente || (deporte === 'Futbol' && !equipo)
              "
              @click="inscribir()"
              >Agregar</v-btn
            >
          </v-card-actions>
        </v-card-text>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-chip class="ma-0" label color="transparent" text-color="black">
                <h3>
                  Jugadores inscriptos en
                  {{
                    sistemaCompetencia === "Torneo" ? "el torneo" : "la liga"
                  }}
                </h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Búsqueda de jugadores"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="mt-4">
              <v-select
                v-model="filtroTipo"
                :items="['Todos', 'Jugadores', 'Público']"
                label="Tipo"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" sm="6" class="mt-4">
              <v-btn
                color="red darken-1"
                dark
                small
                @click="imprimirPDF"
                :disabled="!listaInscriptos.length"
              >
                <v-icon left small>mdi-file-pdf-box</v-icon>
                Imprimir PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            v-if="listaInscriptos.length"
            :headers="
              (deporte === 'Padel' || deporte === 'Tenis') &&
              tipoCompetencia === 'Dobles'
                ? headersDobles
                : deporte === 'Futbol'
                ? headersFutbol
                : headers
            "
            :items="listaFiltrada"
            class="elevation-1"
            locale="es-ar"
            item-key="idCrobro"
            :items-per-page="10"
            ref="myTable"
            :disable-sort="true"
            :footer-props="{
              itemsPerPageText: 'Filas por página',
            }"
            :search="search"
            no-results-text="No hay jugadores a mostrar con la búsqueda ingresada."
          >
            <template v-slot:item.pagado="{ item }">
              <v-simple-checkbox
                v-model="item.pagado"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.esPublico="{ item }">
              <v-chip
                x-small
                :color="item.esPublico ? 'orange' : 'primary'"
                dark
              >
                {{ item.esPublico ? "Público" : "Jugador" }}
              </v-chip>
            </template>
            <template v-slot:item.pareja="{ item }">
              <v-select
                v-if="
                  (deporte === 'Padel' || deporte === 'Tenis') &&
                  tipoCompetencia === 'Dobles'
                "
                :value="
                  listaInscriptos.find((j) => j.idJugador === item.idPareja) ||
                  null
                "
                :items="opcionesPareja(item)"
                item-text="nombreJugador"
                item-value="idJugador"
                return-object
                clearable
                dense
                hide-details
                placeholder="Sin pareja"
                style="min-width: 160px"
                no-data-text="No hay jugadores diponibles para emparejar"
                @change="asignarPareja(item, $event)"
                @click:clear="asignarPareja(item, null)"
              ></v-select>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    medium
                    v-on="on"
                    color="green"
                    class="mr-3"
                    v-bind="attrs"
                    @click.stop="caracteristicas(item)"
                    >mdi-list-box</v-icon
                  >
                </template>
                <span>Características Jugador</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    medium
                    v-on="on"
                    class="mr-3"
                    color="red"
                    v-bind="attrs"
                    @click="borrarJugador(item)"
                    >mdi-delete</v-icon
                  >
                </template>
                <span>Eliminar jugador inscripto</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="$store.getters.tieneRol(5)"
                    medium
                    class="mr-3"
                    color="#d35400"
                    v-on="on"
                    v-bind="attrs"
                    @click.stop="cobrar(item)"
                    >mdi-currency-usd</v-icon
                  >
                </template>
                <span>Consumos</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <v-alert class="mt-4" color="purple" dark outlined v-else>
            No hay jugadores inscriptos para
            {{ sistemaCompetencia === "Torneo" ? "este torneo" : "esta liga" }}.
          </v-alert>
        </v-card-text>
        <BuscarJugadorTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarJugadorTurno>
        <ConsumosWrapper
          :visible="showNuevoConsumo"
          :idInscripcion="editedItem.idInscripcion"
          :pacienteTurno="editedItem.nombreJugador"
          :celular="editedItem.celularJugador"
          :nombrePaciente="editedItem.nombreJugador"
          @close="cierraNuevoConsumo"
        ></ConsumosWrapper>
        <CaracteristicasJugador
          :visible="showCaracteristicas"
          :idPaciente="caracteristicasItem.idJugador"
          :nombrePaciente="caracteristicasItem.nombreJugador"
          @close="cierraCaracteristicas"
        ></CaracteristicasJugador>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import BuscarJugadorTurno from "@/components/Turnos/BuscarJugadorTurno.vue";
import ConsumosWrapper from "../Consumos/ConsumosWrapper.vue";
import CaracteristicasJugador from "../Gestion/Jugadores/CaracteristicasJugador.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    paciente: {
      dni: null,
      apellidos: null,
      nombres: null,
      idPaciente: null,
    },
    showBuscarPaciente: false,
    showNuevoConsumo: false,
    showCaracteristicas: false,
    caracteristicasItem: {},
    editedItem: {},
    listaInscriptos: [],
    esPublico: false,
    filtroTipo: "Todos",
    headers: [
      { text: "Tipo", value: "esPublico" },
      { text: "Jugador", value: "nombreJugador" },
      { text: "Celular", value: "celularJugador" },
      { text: "Acciones", value: "actions" },
    ],
    headersDobles: [
      { text: "Tipo", value: "esPublico" },
      { text: "Jugador", value: "nombreJugador" },
      { text: "Celular", value: "celularJugador" },
      { text: "Pareja", value: "pareja" },
      { text: "Acciones", value: "actions" },
    ],
    headersFutbol: [
      { text: "Tipo", value: "esPublico" },
      { text: "Jugador", value: "nombreJugador" },
      { text: "Celular", value: "celularJugador" },
      { text: "Equipo", value: "equipo" },
      { text: "Acciones", value: "actions" },
    ],
    equipo: "",
    equipos: [],
    search: "",
  }),

  props: [
    "visible",
    "idTorneo",
    "infoTorneo",
    "sistemaCompetencia",
    "deporte",
    "configuraciones",
    "tipoCompetencia",
  ],
  components: {
    BuscarJugadorTurno,
    ConsumosWrapper,
    CaracteristicasJugador,
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarJugadoresInscriptos();
          if (this.deporte === "Futbol") {
            this.buscarEquipos();
          }
          return this.visible;
        }
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    listaFiltrada() {
      if (this.filtroTipo === "Jugadores")
        return this.listaInscriptos.filter((i) => !i.esPublico);
      if (this.filtroTipo === "Público")
        return this.listaInscriptos.filter((i) => i.esPublico);
      return this.listaInscriptos;
    },
    opcionesPareja() {
      return (item) =>
        this.listaInscriptos.filter(
          (j) =>
            j.idJugador !== item.idJugador &&
            (j.idPareja === null ||
              j.idPareja === undefined ||
              j.idJugador === item.idPareja),
        );
    },
  },

  methods: {
    cobrar(item) {
      this.editedItem = Object.assign({}, item);
      this.showNuevoConsumo = true;
    },
    caracteristicas(item) {
      this.caracteristicasItem = Object.assign({}, item);
      this.showCaracteristicas = true;
    },
    cierraCaracteristicas() {
      this.showCaracteristicas = false;
    },
    cierraNuevoConsumo() {
      this.showNuevoConsumo = false;
    },
    buscarEquipos() {
      let configuraciones = null;
      if (this.configuraciones) {
        configuraciones = JSON.parse(this.configuraciones);
      }
      this.equipos = this.generarOpcionesEquipos(configuraciones);
    },
    generarOpcionesEquipos(config) {
      if (!config) return [];

      const equipos = new Map(); // id → nombre (evita duplicados)

      const agregarEquipo = (equipo) => {
        if (!equipo?.id) return;
        equipos.set(equipo.id, equipo.nombre);
      };

      // 🟢 LIGA
      if (this.sistemaCompetencia === "Liga") {
        if (!Array.isArray(config.equipos)) return [];

        config.equipos.forEach(agregarEquipo);
      }

      // 🟢 TORNEO CON ZONAS
      else if (Array.isArray(config.zonas)) {
        config.zonas.forEach((zona) => {
          if (!Array.isArray(zona.partidos)) return;

          zona.partidos.forEach((p) => {
            agregarEquipo(p.local);
            agregarEquipo(p.visitante);
          });
        });
      }

      // 🟢 TORNEO SIN ZONAS
      else if (Array.isArray(config.rondas)) {
        config.rondas.forEach((ronda) => {
          if (!Array.isArray(ronda.partidos)) return;

          ronda.partidos.forEach((p) => {
            agregarEquipo(p.local);
            agregarEquipo(p.visitante);
          });
        });
      }

      return [...equipos.entries()].map(([id, nombre]) => ({
        value: nombre,
        text: nombre,
      }));
    },
    borrarJugador(item) {
      this.$swal({
        title: "Borrar jugador inscripto",
        text: "¿Desea borrar la inscripción del jugador?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await axios.get("/Torneos/BorrarInscripcion", {
              params: {
                idInscripcion: item.idInscripcion,
              },
            });
            this.showAlert({
              timer: 3200,
              icon: "success",
              title: "Jugador inscripto borrado correctamente.",
              vm: this,
            });
            setTimeout(() => {
              this.buscarJugadoresInscriptos();
            }, 500);
          } catch (error) {
            console.log(error);
            this.showAlert({
              timer: 2200,
              icon: "warning",
              title: "El jugador inscripto no pudo ser borrado.",
              vm: this,
            });
          }
        }
      });
    },
    async buscarJugadoresInscriptos() {
      try {
        const { data: inscriptos } = await axios.get("/Torneos/GetInscriptos", {
          params: {
            idTorneo: this.idTorneo,
          },
        });
        this.listaInscriptos = inscriptos || [];
      } catch (error) {
        console.log(error);
        this.listaInscriptos = [];
      }
    },
    async inscribir() {
      if (
        this.listaInscriptos.some(
          (inscripcion) => inscripcion.idJugador === this.paciente.idPaciente,
        )
      ) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: `El jugador ya está inscripto a ${
            this.sistemaCompetencia === "Torneo" ? "éste torneo." : "ésta liga"
          }`,
          vm: this,
        });
        return;
      }

      const datosInscripcion = {
        idTorneo: this.idTorneo,
        idLiga: 0,
        idJugador: this.paciente.idPaciente,
        equipo: this.equipo || "",
        esPublico: this.esPublico,
      };
      try {
        await axios.post("/Torneos/InscribirJugador", datosInscripcion);
        this.showAlert({
          timer: 3200,
          icon: "success",
          title: "Jugador inscripto correctamente.",
          vm: this,
        });
        this.vaciarModels();
        setTimeout(() => {
          this.buscarJugadoresInscriptos();
        }, 500);
      } catch (error) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: "El jugador no pudo ser inscripto.",
          vm: this,
        });
      }
    },
    seleccionarPaciente(item) {
      this.paciente.dni = item.nrodocumento;
      this.paciente.apellidos = item.apellidos;
      this.paciente.nombres = item.nombres;
      this.paciente.idPaciente = item.idpaciente;
      this.showBuscarPaciente = false;
    },

    buscarPacienteDni() {
      if (isNaN(this.paciente.dni)) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: "El D.N.I. debe estar compuesto sólo por números.",
          vm: this,
        });
        this.paciente.dni = "";
        this.paciente.idPaciente = 0;
        return;
      }
      if (this.paciente.dni != "" && this.paciente.dni != null)
        this.paciente.dni = parseInt(this.paciente.dni);

      const pacientesData = {
        dni: this.paciente.dni,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Paciente/GetPacienteDniTurno?", {
          params: {
            dni: pacientesData.dni,
            idInstitucion: pacientesData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != "" && response.data != null) {
            self.paciente.apellidos = response.data.apellidos;
            self.paciente.nombres = response.data.nombres;
            self.paciente.idPaciente = response.data.idpaciente;
          } else {
            self.vaciarModels();
            self.paciente.idPaciente = 0;
          }
        })
        .catch(function (error) {});
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    upper() {
      if (this.paciente.apellidos != null)
        this.paciente.apellidos = this.paciente.apellidos
          .toString()
          .toUpperCase();
    },
    upperNombres() {
      if (this.paciente.nombres != null)
        this.paciente.nombres = this.paciente.nombres.toString().toUpperCase();
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    vaciarModels() {
      this.paciente.apellidos = "";
      this.paciente.nombres = "";
      this.paciente.idPaciente = null;
      this.paciente.dni = "";
      this.esPublico = false;
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    async asignarPareja(inscripcion, parejaSeleccionada) {
      try {
        await axios.post("/Torneos/AsignarPareja", {
          idInscripcion: inscripcion.idInscripcion,
          idInscripcionPareja: parejaSeleccionada?.idInscripcion ?? 0,
        });
        await this.buscarJugadoresInscriptos();
      } catch (error) {
        this.showAlert({
          icon: "warning",
          title: "No se pudo asignar la pareja.",
          vm: this,
        });
      }
    },
    imprimirPDF() {
      const lista = this.listaFiltrada;
      if (!lista.length) return;

      const esDobles =
        (this.deporte === "Padel" || this.deporte === "Tenis") &&
        this.tipoCompetencia === "Dobles";
      const esFutbol = this.deporte === "Futbol";

      let columnHeader;
      let rows = [];

      if (esFutbol) {
        columnHeader = ["#", "Jugador", "Celular", "Equipo", "Tipo"];
        lista.forEach((item, idx) => {
          rows.push([
            idx + 1,
            item.nombreJugador || "",
            item.celularJugador || "",
            item.equipo || "",
            item.esPublico ? "Público" : "Jugador",
          ]);
        });
      } else if (esDobles) {
        columnHeader = ["#", "Jugador", "Celular", "Pareja", "Tipo"];
        lista.forEach((item, idx) => {
          const pareja = this.listaInscriptos.find(
            (j) => j.idJugador === item.idPareja,
          );
          rows.push([
            idx + 1,
            item.nombreJugador || "",
            item.celularJugador || "",
            pareja ? pareja.nombreJugador : "—",
            item.esPublico ? "Público" : "Jugador",
          ]);
        });
      } else {
        columnHeader = ["#", "Jugador", "Celular", "Tipo"];
        lista.forEach((item, idx) => {
          rows.push([
            idx + 1,
            item.nombreJugador || "",
            item.celularJugador || "",
            item.esPublico ? "Público" : "Jugador",
          ]);
        });
      }

      const doc = new jsPDF("portrait");
      doc.setProperties({
        title: `Inscriptos - ${this.infoTorneo}`,
      });

      const nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      doc.setFontSize(12);
      doc.text(nombreInstitucion, 13, 10);
      doc.setFontSize(10);
      doc.text(
        `${this.sistemaCompetencia === "Torneo" ? "Torneo" : "Liga"}: ${this.infoTorneo}`,
        13,
        17,
      );
      doc.text(`Total inscriptos: ${lista.length}`, 13, 23);

      doc.setFontSize(16);
      doc.text(
        "Lista de Inscriptos",
        doc.internal.pageSize.getWidth() / 2,
        33,
        { align: "center" },
      );

      doc.autoTable(columnHeader, rows, {
        startY: 39,
        didParseCell: function (table) {
          if (table.section === "head") {
            table.cell.styles.fillColor = "#c4c5c5";
          }
        },
      });

      window.open(doc.output("bloburl"), "_blank");
    },
  },
};
</script>
